<template>
  <div class="mt-16">
    <div class="mb-6 w-full flex items-center justify-between">
      <!-- Left: Edit Link -->
      <LayoutEditLink />
      <!-- Right: Back to Top Button -->
      <LayoutBackToTop />
    </div>
    <LayoutPrevNext />
  </div>
</template>
